// theme.config.ts

import { defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  theme: {
    tokens: {
      fonts: {
        heading: { value: `'Poppins', sans-serif` },
        body: { value: `'Poppins', sans-serif` },
      },
    },
    semanticTokens: {
      colors: {
        blue: {
          default: { value: "{colors.blue.900}" },
          _hover: { value: "{colors.blue.800}" },
          _active: { value: "{colors.blue.900}" },
        },
      },
    },
  },
});

export default config;
